import * as angular from 'angular';
import { goCacheDef } from './go-cache.factory';

export const goCache = angular.module('go.cache', [])
	.factory('GoCache', goCacheDef)
	.name;
